import { render, staticRenderFns } from "./CollegeNotice.vue?vue&type=template&id=7df4cd06&scoped=true&"
import script from "./CollegeNotice.vue?vue&type=script&lang=js&"
export * from "./CollegeNotice.vue?vue&type=script&lang=js&"
import style0 from "./CollegeNotice.vue?vue&type=style&index=0&id=7df4cd06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df4cd06",
  null
  
)

export default component.exports